var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75052 4.49983V2.24965C6.75052 1.01213 5.73787 -0.000520229 4.50035 -0.000520229H2.25017C1.01265 -0.000520229 0 1.01213 0 2.24965V4.49983C0 5.73735 1.01265 6.75 2.25017 6.75H4.50035C5.73787 6.75 6.75052 5.73735 6.75052 4.49983Z",
    fill: "#E9A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75052 12.7498V10.4997C6.75052 9.26213 5.73787 8.24948 4.50035 8.24948H2.25017C1.01265 8.24948 0 9.26213 0 10.4997V12.7498C0 13.9873 1.01265 15 2.25017 15H4.50035C5.73787 15 6.75052 13.9873 6.75052 12.7498Z",
    fill: "#E9A5F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9956 4.49983V2.24965C14.9956 1.01213 13.983 -0.000520229 12.7455 -0.000520229H10.4953C9.25777 -0.000520229 8.24512 1.01213 8.24512 2.24965V4.49983C8.24512 5.73735 9.25777 6.75 10.4953 6.75H12.7455C13.983 6.75 14.9956 5.73735 14.9956 4.49983Z",
    fill: "#E9A5F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9956 12.7498V10.4997C14.9956 9.26213 13.983 8.24948 12.7455 8.24948H10.4953C9.25777 8.24948 8.24512 9.26213 8.24512 10.4997V12.7498C8.24512 13.9873 9.25777 15 10.4953 15H12.7455C13.983 15 14.9956 13.9873 14.9956 12.7498Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllicon);
export default __webpack_public_path__ + "static/media/allicon.50a9c70518c913e26931b757998605f1.svg";
export { ForwardRef as ReactComponent };